module.exports = __webpack_public_path__ + "assets/icon-dashboard-component.2371596a.svg";